import React from 'react';

import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

// Local components
import { ErrorBoundary } from '../../utils';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
    minHeight: '100%',
  },
}));

function EmptyLayout(props) {
  const { children } = props;

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ErrorBoundary>{children}</ErrorBoundary>
    </div>
  );
}

EmptyLayout.propTypes = {
  children: PropTypes.any,
};

export default EmptyLayout;
